export enum RegistrationStep {
	PersonalInfo = 0,
	DocumentPhotos = 1,
	ResidenceDocument = 2,
	DocumentDetails = 3,
	IdentityReview = 4,
	PaymentMethod = 5,
	WorkStatus = 6,
	Inn = 7,
	Snils = 8,
	ResidentCode = 9,
	MyTaxIntro = 10,
	MyTaxAccess = 11,
	MyTaxChecking = 12,
	MyTaxSuccess = 13,
	MyTaxNameMismatch = 14,
	MyTaxAccessError = 15,
	MyTaxFnsPending = 16,
	MyTaxNotSelfEmployed = 17,
	MyTaxLoadError = 18,
	RegistrationComplete = 19,
	/** Ожидание после анкеты партнёра (Альфа-банк) в iframe. */
	PartnerAgreementChecking = 20,
	/** Отдельный экран «Выберите гражданство» больше не в основном флоу: поле на «Давайте познакомимся». */
	Citizenship = 21,
	/** ИНН или налоговый идентификатор — после паспортных данных, до сверки. */
	IdentificationInn = 22,
	/** Анкета Альфа закрыта, signed не пришёл после поллинга — «Ждём ответ». */
	PartnerAgreementPending = 23,
}

/** Query `?edit=…` — вход в регистрацию на конкретный экран с профиля. */
export const REGISTRATION_EDIT_PARAM = 'edit';
export const REGISTRATION_EDIT_PHOTOS_PARAM = REGISTRATION_EDIT_PARAM;
export const REGISTRATION_EDIT_PHOTOS_VALUE = 'photos';
export const REGISTRATION_EDIT_PHOTOS_SEARCH = `${REGISTRATION_EDIT_PARAM}=${REGISTRATION_EDIT_PHOTOS_VALUE}`;
export const REGISTRATION_EDIT_STATUSES_VALUE = 'statuses';
export const REGISTRATION_EDIT_STATUSES_SEARCH = `${REGISTRATION_EDIT_PARAM}=${REGISTRATION_EDIT_STATUSES_VALUE}`;
export const REGISTRATION_EDIT_PERSONAL_VALUE = 'personal';
export const REGISTRATION_EDIT_PASSPORT_VALUE = 'passport';
export const REGISTRATION_EDIT_INN_VALUE = 'inn';

export const isMyTaxStep = (step: RegistrationStep): boolean => {
	return (
		step === RegistrationStep.MyTaxIntro ||
		step === RegistrationStep.MyTaxAccess ||
		step === RegistrationStep.MyTaxChecking ||
		step === RegistrationStep.MyTaxSuccess ||
		step === RegistrationStep.MyTaxNameMismatch ||
		step === RegistrationStep.MyTaxAccessError ||
		step === RegistrationStep.MyTaxFnsPending ||
		step === RegistrationStep.MyTaxNotSelfEmployed ||
		step === RegistrationStep.MyTaxLoadError ||
		step === RegistrationStep.PartnerAgreementChecking ||
		step === RegistrationStep.PartnerAgreementPending
	);
};

export const isDocumentsRegistrationStep = (step: RegistrationStep): boolean => {
	return (
		step === RegistrationStep.DocumentPhotos ||
		step === RegistrationStep.ResidenceDocument ||
		step === RegistrationStep.DocumentDetails
	);
};

export const REGISTRATION_STEP_COUNT = 24;

/** Шаг выбора/подключения статусов после «Давайте всё сверим». */
export const WORK_STATUS_STEP_ENABLED = true;

/**
 * Шаги основной регистрации. Первый — «Давайте познакомимся» (там же гражданство).
 * Выбор статуса занятости — последний шаг пагинации
 * («Давайте всё сверим» — предпоследний). Подключение конкретного статуса — своя пагинация.
 *
 * `hasResidenceDocument` — отдельный экран «Подтвердите место проживания» после налогового идентификатора.
 * `includeDocumentPhotosStep` — отдельный экран фото. Сейчас фото у всех на экране данных документа, как у РФ.
 */
export const getRegistrationMainSteps = (
	hasResidenceDocument: boolean,
	includeDocumentPhotosStep = true,
): RegistrationStep[] => {
	const steps: RegistrationStep[] = [RegistrationStep.PersonalInfo];

	if (includeDocumentPhotosStep) {
		steps.push(RegistrationStep.DocumentPhotos);
	}

	steps.push(RegistrationStep.DocumentDetails);
	steps.push(RegistrationStep.IdentificationInn);

	// Сразу после налогового идентификатора, до сверки.
	if (hasResidenceDocument) {
		steps.push(RegistrationStep.ResidenceDocument);
	}

	steps.push(RegistrationStep.IdentityReview);

	if (WORK_STATUS_STEP_ENABLED) {
		steps.push(RegistrationStep.WorkStatus);
	}

	return steps;
};

export const getRegistrationProgress = (
	step: RegistrationStep,
	hasResidenceDocument: boolean,
	includeDocumentPhotosStep = true,
): {currentStep: number; totalSteps: number} | null => {
	const steps = getRegistrationMainSteps(hasResidenceDocument, includeDocumentPhotosStep);
	const index = steps.indexOf(step);

	if (index < 0) {
		return null;
	}

	return {currentStep: index, totalSteps: steps.length};
};
